import React, { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useDroppable } from '@dnd-kit/core';
import { useIntl } from 'react-intl';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ExtractLinesAction } from '@/domain/textract';
import {
  DocumentDragItemContext,
  type TwoWayMatchTableDropZone,
} from '@/pages/document/components/DocumentDragAndDrop/dragData';

import { alpha } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

const DropContainer = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const isTableDragged = useContext(DocumentDragItemContext)?.kind === 'twoWayMatchTable';
  const zone = useMemo<TwoWayMatchTableDropZone>(
    () => ({ dropTwoWayMatchTable: () => dispatch(ExtractLinesAction()) }),
    [dispatch],
  );
  const { setNodeRef } = useDroppable({ id: 'two-way-match-table-drop-zone', data: zone });

  return (
    <Stack
      // 28px add column button size
      width="calc(100% + 28px)"
      height="100%"
      justifyContent="center"
      alignItems="center"
      zIndex="11"
      ref={setNodeRef}
      // takes the pointer during a drag, so the cells under the zone do not react to it
      className="droppable"
      position="absolute"
      display={isTableDragged ? 'flex' : 'none'}
      borderRadius={1}
      bgcolor={alpha(grey[600], 0.6)}
    >
      <Typography variant="h6" color="common.white" textAlign="center">
        {formatMessage({
          id: '3WayMatching.dropZone',
          defaultMessage: 'Drop the table here to import line items from a document',
        })}
      </Typography>
    </Stack>
  );
};

export default DropContainer;
